// import React, { useState, useRef, useEffect } from "react";
// import Avatar from "./Avatar";
// import profileIcon from "../../assets/images/profile-dummy.png";
// import Button from "../Buttons/Button";
// import { useDispatch, useSelector } from "react-redux";
// import { logout } from "../../redux/slices/auth/authSlice";
// import { selectUser } from "../../redux/slices/auth/authSelectors";
// import { formatWords } from "../../utils/stringUtils";
// import { persistor } from "../../redux/store";
// import DropdownMenu from "../Buttons/DropdownMenu";
// import { useNavigate } from "react-router-dom";
// import CustomToggle from "../FormFields/Custom/CustomToggle";

// const Header = () => {
//   const ENV = import.meta.env.VITE_APP_ENV || "local";
//   const dispatch = useDispatch();
//   const user = useSelector(selectUser);
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef(null);
//   const buttonRef = useRef(null);
//   const navigate = useNavigate();

//   const toggleDropdown = (event) => {
//     event.stopPropagation(); // Prevent immediate closing
//     setIsOpen((prev) => !prev);
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         dropdownRef.current &&
//         !dropdownRef.current.contains(event.target) &&
//         buttonRef.current &&
//         !buttonRef.current.contains(event.target)
//       ) {
//         setIsOpen(false);
//       }
//     };

//     document.addEventListener("click", handleClickOutside);
//     return () => document.removeEventListener("click", handleClickOutside);
//   }, []);

//   const [portalValue, setPortalValue] = useState(
//     localStorage.getItem("portalKW")
//   );

//   return (
//     <div className="px-6 py-5 flex justify-end items-center gap-3 shadow-lg relative">
//       {ENV === "local" && (
//         <div>
//           <CustomToggle
//             options={["KW", "ATS"]}
//             value={portalValue}
//             onChange={(value) => {
//               setPortalValue(value);
//               localStorage.setItem("portalKW", value);
//             }}
//           />
//         </div>
//       )}
//       <div className="flex items-center gap-3">
//         <Button type="icon" icon="search" color="white" />
//         <Button type="icon" icon="local_activity" color="white" />
//         <Button type="icon" icon="notifications" color="white" />
//         <Button type="icon" icon="link" color="white" />
//         {/* <Button type="icon" icon="apps" color="white" /> */}
//         <DropdownMenu
//           // minWidth="full"
//           MenuSection={
//             <div className="flex flex-col">
//               <Button
//                 title={"QuickBooks"}
//                 variant="text"
//                 color="black"
//                 className="!justify-start py-1"
//                 onClick={() => navigate("/quickbooks")}
//               />
//             </div>
//           }
//         >
//           <Button type="icon" icon="apps" color="white" />
//         </DropdownMenu>
//       </div>

//       {/* Button needs a ref to prevent immediate closing */}
//       <button ref={buttonRef} onClick={toggleDropdown}>
//         <Avatar
//           size="md"
//           alt="Omkar Sahu"
//           src={user?.data.profilePhotoUrl || profileIcon}
//         />
//       </button>

//       {/* Dropdown with smooth transition */}
//       <div
//         ref={dropdownRef}
//         className={`absolute z-[999] top-[60px] right-[24px] bg-white shadow-lg rounded-lg w-60 transform transition-all duration-200 ease-in-out
//         ${
//           isOpen
//             ? "opacity-100 scale-100"
//             : "opacity-0 scale-95 pointer-events-none"
//         }`}
//       >
//         <div className="w-full bg-primary px-3 py-4 flex items-center gap-1">
//           <Avatar
//             size="xl"
//             alt="Omkar Sahu"
//             src={user?.data.profilePhotoUrl || profileIcon}
//           />
//           <div className="text-white flex-1">
//             <h5 className="line-clamp-1 text-sm font-medium">
//               {formatWords(
//                 "Guest User",
//                 user?.data.firstName,
//                 user?.data.lastName
//               )}
//             </h5>
//             <p className="line-clamp-1 text-sm">
//               {user?.data.jobTitle || "--"}
//             </p>
//           </div>
//           <Button type="icon" icon="edit_square" />
//         </div>
//         <div className="w-full flex flex-1">
//           <Button
//             title="Logout"
//             variant="text"
//             color="black"
//             icon="logout"
//             size="xl"
//             className="flex flex-1 !justify-start"
//             onClick={() => {
//               // dispatch(logout());
//               dispatch({ type: "RESET_STORE" });
//               persistor.purge();
//             }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Header;
import React, { useState, useRef, useEffect } from "react";
import Avatar from "./Avatar";
import profileIcon from "../../assets/images/profile-dummy.png";
import Button from "../Buttons/Button";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slices/auth/authSlice";
import { selectUser } from "../../redux/slices/auth/authSelectors";
import { persistor } from "../../redux/store";
import DropdownMenu from "../Buttons/DropdownMenu";
import { useNavigate } from "react-router-dom";
import CustomToggle from "../FormFields/Custom/CustomToggle";
import qbLogo from "../../assets/services/qb.svg";
import wfLogo from "../../assets/services/wf.svg";
import atsLogo from "../../assets/services/ats.svg";
import bsLogo from "../../assets/services/bs.svg";

import Divider from "./Divider";
import SmartTooltip from "../Info/SmartTooltip";
import { getItem, setItem } from "../../utils/localStorageUtils";
import DropdownMenuNew from "../Buttons/DropdownMenuNew";
import Badge from "../Info/Badge";
import { updateTotalCountToStore } from "../../utils/wf-notifications";
import { useLoginUser } from "../../hooks/useLoginUser";
import CkTextEditor from "../CkTextEditor/CkTextEditor";
import FormFieldSet from "../FormFields/FormFieldSet";
import Drawer from "../Modal/Drawer";
import FileUploadNew from "../FormFields/FileUploadNew";
import { logoutUser } from "../../redux/slices/auth/authApi";
import RaiseATicketDrawer from "./Modals/RaiseATicketDrawer";
import GlobalSearchDrawer from "./Modals/GlobalSearchDrawer";
import { MODULE_ACCESS, sampleCompanies } from "../../assets/data/enumData";
import { BUILD_VERSION } from "../../configs/buildVersion";
import { getBuildVersion } from "../../redux/slices/buildVersion/buildVersionApi";
import { setVersionNum } from "../../redux/slices/buildVersion/buildVersionSlice";
import { setRefreshIconHandler } from "../../utils/logoutHandler";
import { set } from "lodash";
import { useSocket } from "../../hooks/useSocket";
import HeaderLogo from "../../assets/images/HeaderLogoNew.svg";
import CustomSelectWithDefault from "../FormFields/Custom/CustomSelectWithDefault";
import { trackEvent } from "../../utils/mixpanelService";
import { initAppZoom, setAppZoom } from "../../redux/slices/jobs/jobsSlice";
import HeaderStyle from "../Titles/HeaderStyle";
import PageHeader from "./PageHeader";
import ModuleToggleButton from "../Buttons/ModuleToggleButton";

const Header = () => {
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const notificationStore = useSelector((state) => state.wfNotification);
  const { versionNum } = useSelector((state) => state.buildVersion);
  const appZoom = useSelector((state) => state.jobs?.appZoom ?? 1);
  const dispatch = useDispatch();

  useEffect(() => {
    // initialize zoom from localStorage via saga
    dispatch(initAppZoom());
  }, [dispatch]);

  // const resetZoom = () => dispatch(setAppZoom(1));
  // const zoomIn = () =>
  //   dispatch(setAppZoom(Math.min(appZoom + 0.1, 2)));
  // const zoomOut = () =>
  //   dispatch(setAppZoom(Math.max(appZoom - 0.1, 0.5)));

  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     if (!e.ctrlKey) return;

  //     // Zoom In (Ctrl + +)
  //     if (e.key === "+" || e.key === "=") {
  //       e.preventDefault();
  //       dispatch(setAppZoom(Math.min(appZoom + 0.1, 2)));
  //     }

  //     // Zoom Out (Ctrl + -)
  //     if (e.key === "-") {
  //       e.preventDefault();
  //       dispatch(setAppZoom(Math.max(appZoom - 0.1, 0.5)));
  //     }

  //     // Reset (Ctrl + 0)
  //     if (e.key === "0") {
  //       e.preventDefault();
  //       dispatch(setAppZoom(1));
  //     }
  //   };

  //   window.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [dispatch, appZoom]);


const MIN_ZOOM = 0.8;
const MAX_ZOOM = 1.2;
const STEP = 0.1;

const resetZoom = () => dispatch(setAppZoom(1));
const zoomIn = () =>
  dispatch(setAppZoom(Math.min(Number((appZoom + STEP).toFixed(2)), MAX_ZOOM)));
const zoomOut = () =>
  dispatch(setAppZoom(Math.max(Number((appZoom - STEP).toFixed(2)), MIN_ZOOM)));

// useEffect(() => {
//   const handleKeyDown = (e) => {
//     if (!e.ctrlKey) return;
//     // Don't zoom while typing in input fields
//     const tag = e.target.tagName;
//     if (tag === "INPUT" || tag === "TEXTAREA" || e.target.isContentEditable) {
//       return;
//     }
//     const currentZoom = Number(localStorage.getItem("appZoom")) || 1;
//     // Ctrl + +  OR Ctrl + =
//     if (e.key === "+" || e.key === "=") {
//       e.preventDefault();
//       const newZoom = Math.min(
//         Number((currentZoom + STEP).toFixed(2)),
//         MAX_ZOOM
//       );
//       dispatch(setAppZoom(newZoom));
//     }
//     // Ctrl + -
//     if (e.key === "-") {
//       e.preventDefault();
//       const newZoom = Math.max(
//         Number((currentZoom - STEP).toFixed(2)),
//         MIN_ZOOM
//       );
//       dispatch(setAppZoom(newZoom));
//     }
//     // Ctrl + 0
//     if (e.key === "0") {
//       e.preventDefault();
//       dispatch(setAppZoom(1));
//     }
//   };

//   window.addEventListener("keydown", handleKeyDown);
//   return () => window.removeEventListener("keydown", handleKeyDown);
// }, [dispatch,appZoom]);

useEffect(() => {
  const getCurrentZoom = () =>
    Number(localStorage.getItem("appZoom")) || 1;
  const isTyping = (target) => {
    const tag = target.tagName;
    return (
      tag === "INPUT" ||
      tag === "TEXTAREA" ||
      target.isContentEditable
    );
  };
  // 🔹 Ctrl + Keyboard
  const handleKeyDown = (e) => {
    if (!e.ctrlKey) return;
    if (isTyping(e.target)) return;
    const currentZoom = getCurrentZoom();
    // Ctrl + + OR Ctrl + =
    if (e.key === "+" || e.key === "=") {
      e.preventDefault();
      const newZoom = Math.min(
        Number((currentZoom + STEP).toFixed(2)),
        MAX_ZOOM
      );
      dispatch(setAppZoom(newZoom));
    }
    // Ctrl + -
    if (e.key === "-") {
      e.preventDefault();
      const newZoom = Math.max(
        Number((currentZoom - STEP).toFixed(2)),
        MIN_ZOOM
      );
      dispatch(setAppZoom(newZoom));
    }
    // Ctrl + 0
    if (e.key === "0") {
      e.preventDefault();
      dispatch(setAppZoom(1));
    }
  };
  // 🔹 Ctrl + Mouse Wheel
  const handleWheel = (e) => {
    if (!e.ctrlKey) return;
    if (isTyping(e.target)) return;
    e.preventDefault(); // prevent browser zoom
    const currentZoom = getCurrentZoom();
    if (e.deltaY < 0) {
      // Wheel Up → Zoom In
      const newZoom = Math.min(
        Number((currentZoom + STEP).toFixed(2)),
        MAX_ZOOM
      );
      dispatch(setAppZoom(newZoom));
    } else {
      // Wheel Down → Zoom Out
      const newZoom = Math.max(
        Number((currentZoom - STEP).toFixed(2)),
        MIN_ZOOM
      );
      dispatch(setAppZoom(newZoom));
    }
  };
  window.addEventListener("keydown", handleKeyDown);
  window.addEventListener("wheel", handleWheel, { passive: false });
  return () => {
    window.removeEventListener("keydown", handleKeyDown);
    window.removeEventListener("wheel", handleWheel);
  };
}, [dispatch]);

  const versionIntervalRef = useRef(null);
  const mismatchDetectedRef = useRef(false);

  const { listenEvent, socket, isConnected } = useSocket();

  const ENV = import.meta.env.VITE_APP_ENV || "local";
  // ...
  useEffect(() => {
    if (!socket || !isConnected) return;

    const removeListener = listenEvent(
      "server:build_version_update",
      (data) => {
        const serverVersion = data?.versionNum;
        if (serverVersion && serverVersion !== BUILD_VERSION) {
          dispatch(setVersionNum(serverVersion));
          setShowRefresh(true);
          console.log("new Buildversion");
        }
      },
    );

    return () => {
      if (removeListener) removeListener();
    };
  }, [listenEvent, dispatch, socket, isConnected]);
  const user = useSelector(selectUser);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const navigate = useNavigate();
  const [notificationCount, setNotificationCount] = useState(0);
  const [selectedCompany, setSelectedCompany] = useState("deloitte");
  const [defaultCompany, setDefaultCompany] = useState("deloitte");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSearchOpenDrawer, setIsSearchOpenDrawer] = useState(false);
  const [showRefresh, setShowRefresh] = useState(false);
  const portal = getItem("portal");
  const module = loginUserData?.role?.module;
  const allowedModules = MODULE_ACCESS[module] || [];
  const toggleDropdown = (event) => {
    event.stopPropagation(); // Prevent immediate closing
    setIsOpen((prev) => !prev);
  };

  // const fetchBuildVersions = async () => {
  //   try {
  //     const buildVersion = await getBuildVersion();
  //
  //     if (buildVersion?.success) {
  //       const serverVersion = buildVersion?.data?.data?.[0]?.versionNum;
  //
  //       if (!serverVersion) return;
  //
  //       dispatch(setVersionNum(serverVersion));
  //
  //       if (serverVersion !== BUILD_VERSION) {
  //         mismatchDetectedRef.current = true;
  //         setShowRefresh(true);
  //
  //         if (versionIntervalRef.current) {
  //           clearInterval(versionIntervalRef.current);
  //           versionIntervalRef.current = null;
  //         }
  //       }
  //     }
  //   } catch (err) {
  //     console.error('Failed to fetch build version', err);
  //   }
  // };

  // useEffect(() => {
  //   if (versionIntervalRef.current || mismatchDetectedRef.current) return;
  //
  //   fetchBuildVersions();
  //
  //   versionIntervalRef.current = setInterval(
  //     fetchBuildVersions,
  //     3 * 60 * 1000
  //   );
  //
  //   return () => {
  //     if (versionIntervalRef.current) {
  //       clearInterval(versionIntervalRef.current);
  //       versionIntervalRef.current = null;
  //     }
  //   };
  // }, []);

  useEffect(() => {
    setNotificationCount(notificationStore?.totalUnreadCount || 0);
  }, [notificationStore]);

  useEffect(() => {
    if (loginUserUiid) updateTotalCountToStore({ userId: loginUserUiid });
  }, [loginUserUiid]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [portalValue, setPortalValue] = useState(() => {
    const stored = localStorage.getItem("portalKW");
    // If stored is null (first time), default to true (Portal KW mode)
    const initialValue =
      stored === null ? true : stored === "true" || stored === true;
    return initialValue;
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const stored = localStorage.getItem("portalKW");
      const newValue = stored === "true" || stored === true;
      setPortalValue(newValue);
    };

    window.addEventListener("portalKWChanged", handleStorageChange);
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("portalKWChanged", handleStorageChange);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload(true);
  };

  useEffect(() => {
    setRefreshIconHandler(() => {
      setShowRefresh(true);
    });
  }, [dispatch]);
  const handleLogout = async () => {
    await logoutUser();
    await trackEvent({ eventName: "User Logout" });
    dispatch({ type: "RESET_STORE" });
    persistor.purge();
    dispatch(setAppZoom(1));
    // handleRefresh(); // mahee commented
  };

  return (
    <>
      {/* <div className="px-2 md:px-3 lg:px-6 py-5 flex justify-between items-center gap-3 shadow-lg relative"> */}
      <div className="px-2 md:px-3 lg:px-6 py-5 flex justify-end items-center gap-3 shadow-lg relative">
        {/* <div className="flex items-center gap-4">
          <img src={HeaderLogo} alt="companylogo" className="h-8" />
          <div className="w-[250px]">
            <CustomSelectWithDefault
              options={sampleCompanies}
              selected={selectedCompany}
              onChange={(value) => setSelectedCompany(value)}
              placeholder="Select Company"
              showSearch={true}
              showLogo={true}
              defaultValue={defaultCompany}
              onSetDefault={(value) => setDefaultCompany(value)}
              size="sm"
              shadow={true}
              rounded="rounded"
            />
          </div>
        </div> */}
        <div className="flex items-end gap-3">
          {showRefresh && (
            <Button
              type="button"
              className="mr-35"
              icon="refresh"
              variant="text"
              title={"Refresh"}
              onClick={() => handleRefresh()}
            />
          )}
          <div className="flex items-center border border-primary rounded">
            <Button
              type="icon"
              icon="remove"
              variant="text"
              onClick={zoomOut}
            />

            <span className="text-xs w-10 text-center">
              {Math.round(appZoom * 100)}%
            </span>

            <Button
              type="icon"
              icon="add"
              variant="text"
              onClick={zoomIn}
            />

            <Button
              title="Reset"
              variant="text"
              size="sm"
              className="text-xs"
              onClick={resetZoom}
            />
          </div>
          <Button
            type="icon"
            icon="search"
            variant="text"
            color="black"
            onClick={() => setIsSearchOpenDrawer(true)}
          />
          <SmartTooltip
            description={"Raise a Ticket"}
            noicon
            tooltipPosition="bottom"
          >
            <Button
              type="icon"
              icon="local_activity"
              variant="text"
              color="black"
              onClick={() => setIsDrawerOpen(true)}
            />
          </SmartTooltip>
          <SmartTooltip
            description={"Notification"}
            noicon
            tooltipPosition="bottom"
          >
            <Badge value={notificationCount || 0} max={99}>
              <Button
                type="icon"
                icon="notifications"
                variant="text"
                color="black"
                onClick={() => navigate("/notifications")}
              />
            </Badge>
          </SmartTooltip>
          <SmartTooltip
            description={"Quick Links"}
            noicon
            tooltipPosition="bottom"
          >
            <Button type="icon" icon="link" variant="text" color="black" />
          </SmartTooltip>
          {/* <Button type="icon" icon="apps" color="white" /> */}
          <DropdownMenuNew
            // minWidth="full"
            MenuSection={
              <div className="flex flex-col gap-4 px-1 py-1 ">
                {/* <Button
                title={"QuickBooks"}
                variant="text"
                color="black"
                className="!justify-start py-1"
                onClick={() => navigate("/quickbooks")}
              /> */}
                {/* {ENV !== "production" && (
                <>
                  <div className="flex gap-3">
                    <button
                      onClick={() => {
                        // localStorage.setItem("portal", "wf");
                        setItem("portal", "wf"); // save module
                        window.dispatchEvent(new CustomEvent("portalChanged"));
                      }}
                    >
                      <Avatar src={wfLogo} />
                    </button>
                    <button
                      onClick={() => {
                        // localStorage.setItem("portal", "ats");
                        setItem("portal", "ats"); // save module
                        window.dispatchEvent(new CustomEvent("portalChanged"));
                      }}
                    >
                      <Avatar src={atsLogo} />
                    </button>
                    <button
                    onClick={() => {
                      // localStorage.setItem("portal", "bs");
                      setItem("portal", "bs");
                      window.dispatchEvent(new CustomEvent("portalChanged"));
                    }}
                  >
                    <Avatar src={bsLogo} />
                  </button>
                  </div>
                  <Divider />
                </>
              )}
              <div className="flex gap-3">
                <button onClick={() => navigate("/quickbooks")}>
                  <Avatar
                    //size="sm"
                    src={qbLogo}
                  />
                </button>
              </div> */}
                {/* <div className="flex gap-3">
                  {allowedModules.includes("wf") && (
                    <>
                      <button
                        onClick={() => {
                          setItem("portal", "wf");
                          window.dispatchEvent(
                            new CustomEvent("portalChanged"),
                          );
                        }}
                      >
                        <Avatar src={wfLogo} />
                      </button>
                      
                    </>
                  )}
                  {allowedModules.includes("ats") && (
                    <button
                      onClick={() => {
                        setItem("portal", "ats");
                        window.dispatchEvent(new CustomEvent("portalChanged"));
                      }}
                    >
                      <Avatar src={atsLogo} />
                    </button>
                  )}

                  {allowedModules.includes("bs") && (
                    <button
                      onClick={() => {
                        setItem("portal", "bs");
                        window.dispatchEvent(new CustomEvent("portalChanged"));
                      }}
                    >
                      <Avatar src={bsLogo} />
                    </button>
                  )}
                </div> */}

                <div className="flex flex-col">
                  {allowedModules.includes("wf") && (
                    <>
                      <ModuleToggleButton
                        title={"Work Force"}
                        description={"Employee Management"}
                        className="bg-success-500!"
                        active={portal === "wf"}
                        onClick={() => {
                          setItem("portal", "wf");
                          window.dispatchEvent(
                            new CustomEvent("portalChanged"),
                          );
                        }}
                      />
                      <Divider />
                    </>
                  )}
                  {allowedModules.includes("ats") && (
                    <>
                      <ModuleToggleButton
                        title={"Applicant Tracking System"}
                        description={"Candidate Tracking System"}
                        className="bg-leave-500!"
                        active={portal === "ats"}
                        onClick={() => {
                          setItem("portal", "ats");
                          window.dispatchEvent(
                            new CustomEvent("portalChanged"),
                          );
                        }}
                      />
                      <Divider />
                    </>
                  )}
                  {allowedModules.includes("bs") && (
                    <ModuleToggleButton
                      title={"Bench Sales"}
                      description={"Resource Allocation"}
                      className="bg-info-500!"
                      active={portal === "bs"}
                      onClick={() => {
                        setItem("portal", "bs");
                        window.dispatchEvent(new CustomEvent("portalChanged"));
                      }}
                    />
                  )}
                </div>
              </div>
            }
          >
            <Button type="icon" icon="apps" variant="text" color="black" />
          </DropdownMenuNew>
          <button ref={buttonRef} onClick={toggleDropdown}>
            <Avatar
              size="md"
              alt="Omkar Sahu"
              src={user?.data.profilePhotoUrl || profileIcon}
            />
          </button>

          {/* Dropdown with smooth transition */}
          <div
            ref={dropdownRef}
            className={`absolute z-[999] top-[60px] right-[24px] bg-white shadow-lg rounded-lg w-60 transform transition-all duration-200 ease-in-out 
        ${
          isOpen
            ? "opacity-100 scale-100"
            : "opacity-0 scale-95 pointer-events-none"
        }`}
          >
            <div className="w-full bg-primary px-3 py-4 flex items-center gap-1">
              <Avatar
                size="xl"
                alt="Omkar Sahu"
                src={user?.data.profilePhotoUrl || profileIcon}
              />
              <div className="text-white flex-1">
                <h5 className="line-clamp-1 text-sm font-medium">
                  {[user?.data.firstName, user?.data.lastName]
                    .filter(Boolean)
                    .join(" ") || "Guest User"}
                </h5>
                <p className="line-clamp-1 text-sm">
                  {user?.data.jobTitle || "--"}
                </p>
              </div>
              <Button type="icon" icon="edit_square" onClick={() => { navigate("/profile"); }} />
            </div>
            <div className="w-full flex flex-col flex-1">
              <Button
                title="My Profile"
                variant="text"
                color="black"
                icon="account_circle"
                size="xl"
                className="flex flex-1 !justify-start"
                onClick={() => {
                  navigate("/profile");
                }}
              />
              <Button
                title="Logout"
                variant="text"
                color="black"
                icon="logout"
                size="xl"
                className="flex flex-1 !justify-start"
                onClick={() => handleLogout()}
              />
            </div>
          </div>
        </div>
      </div>
      <RaiseATicketDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
      {portal === "ats" && (
        <GlobalSearchDrawer
          isOpen={isSearchOpenDrawer}
          onClose={() => setIsSearchOpenDrawer(false)}
        />
      )}
    </>
  );
};

export default Header;
